import { createAPIConnection } from 'services';
import { FindCategoriesResponse } from './interfaces';
import { requestHandler } from '../helpers';

const api = createAPIConnection('');

export const findCategories = async (pharmacyId: string) => {
	return requestHandler<FindCategoriesResponse[]>(api.get(`/categories/${pharmacyId}`));
};
